import { render, staticRenderFns } from "./fireFightingImpr.vue?vue&type=template&id=313194f0"
import script from "./fireFightingImpr.vue?vue&type=script&lang=js"
export * from "./fireFightingImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313194f0')) {
      api.createRecord('313194f0', component.options)
    } else {
      api.reload('313194f0', component.options)
    }
    module.hot.accept("./fireFightingImpr.vue?vue&type=template&id=313194f0", function () {
      api.rerender('313194f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/fft/fireFightingImpr.vue"
export default component.exports